export { default as NewsletterBlock } from './NewsletterBlock';
